<!------------------------------------------------------------------------------
 File: EventTicketsModule 
 Created by keni.
 with: IntelliJ IDEA
 Date: 03/07/2018
 Time: 14:28
------------------------------------------------------------------------------->
<template>
    <transition name="fade">
        <td>
            <div :class="{
                card:no_card != true
            }" v-if="event_data.hasOwnProperty('event_data')">
                <!--card-header-->
                <div class=""
                        :class="{
                            'card-header':no_card != true
                        }"
                        v-if="no_header != true">
                    <div class=" text-light">
                        <div class=" d-flex justify-content-between align-items-top ">
                            <div>
                                <div class="d-inline-block" v-html=""></div>
                                <div class="d-inline-block dashboard-module-small--value ml-2">
                                    {{lang('title',event_data.event_data.lang)}}
                                </div>
                            </div>
                            <!--<actions-menu-module-->
                            <!--@click_events="actionEventHandler"-->
                            <!--:download="{-->
                            <!--name: settings.file_name + '.' + exportData.type,-->
                            <!--type: exportData.type,-->
                            <!--fields: exportData.json_fields,-->
                            <!--data: sale_records-->
                            <!--}"-->
                            <!--&gt;-->
                            <!--</actions-menu-module>-->
                        </div>
                    </div>
                </div>
                <div class="" :class="{
                            'card-body':no_card != true
                        }">
                    <!--class="table-max-height"-->
                    <!--list the ticket details-->
                    <!--table-responsive-->
                    <template v-if="event_data.hasOwnProperty('tickets')">

                        <div class="">
                            <div class="table d-table w-100">
                                <div class="tbody">
                                    <template
                                            v-for="(tickets,index) in event_data.tickets.sales"

                                    >
                                        <div class="tr cursor-pointer"
                                                v-on:click="showTicketSales(index,tickets)"
                                                :class="{
                                                'bg-primary':show_ticket_id!=null && show_ticket_id == index
                                            }"

                                        >
                                            <!--the title-->
                                            <div :data-ticket-id="index" class="td text-uppercase">
                                                {{lang('title',tickets.ticket_sales[first(tickets.ticket_sales)].ticket.lang)}}
                                            </div>
                                            <!--sold count-->
                                            <div class="td">
                                                Sold: {{tickets.sold_count}}
                                            </div>
                                            <!--refunds-->
                                            <!--<div class="td font-weight-bold">-->
                                            <!--<span>-->
                                            <!--Refunds:-->
                                            <!--</span>-->
                                            <!--<span> {{currency}} {{money(tickets.refunded)}}</span>-->
                                            <!--</div>-->
                                            <!--the total-->
                                            <div class="td ">
                                            <span>
                                            Total:
                                            </span>
                                                <span>
                                            {{currency}} {{money(tickets.sold_total)}}
                                            </span>
                                            </div>
                                        </div>
                                        <template v-if="show_tickets_active && show_ticket_id == index">
                                            <td class="td" colspan="3">
                                                <div
                                                        v-for="(tickets,index) in event_data.tickets.sales"
                                                >
                                                    <transition name="fade">
                                                        <div v-if="show_tickets_active && show_ticket_id == index">
                                                            <event_ticket_sales

                                                                    :sale_route_name="sale_route_name"
                                                                    :sale_route_uri="sale_route_uri"
                                                                    :ticket_sales="show_tickets"
                                                                    :currency="currency"
                                                            ></event_ticket_sales>
                                                        </div>
                                                    </transition>

                                                </div>
                                            </td>
                                        </template>
                                    </template>

                                </div>
                            </div>
                        </div>


                    </template>

                </div>
            </div>

        </td>
    </transition>
</template>

<script>
	import lang from '../../../../../app/Shared/Resources/Assets/js/helpers/lang';
	import {format as formatMoney} from '../../../../../app/Shared/Resources/Assets/js/helpers/money';

	Vue.component('event_ticket_sales', require('./EventTicketSales'));

	export default {
		name: "event-tickets-module",
		components: {},
		props: {
			no_header: Boolean,
            no_card: Boolean,
			event_tickets: {},
			event_data: {},
			title: String,
			currency: String,
			sale_route_name: String,
			sale_route_uri: String,

		},
		created() {
		},
		destroyed() {
		},
		mounted() {
			this.show_tickets = null;
		},
		data() {
			return {

				show_tickets: null,
				show_ticket_id: null,
				show_tickets_active: false,
			}
		},
		methods: {

			showTicketSales(index, tickets) {
				if (index !== this.show_ticket_id) {
					//user hit another row
					// console.log('showTicketSales', 'different',index);
					this.show_tickets_active = true;
					// this.show_ticket_id = index;
					// this.show_tickets = tickets;

				}
				else {
					console.log('showTicketSales', 'same', index);
					//user hit the same row
					this.show_tickets_active = !this.show_tickets_active;
				}

				if (this.show_tickets_active) {
					this.show_ticket_id = index;
					this.show_tickets = tickets.ticket_sales;

					console.log('showTicketSales', 'setting',this.show_tickets);

				}
				else {
					this.show_ticket_id = null;
					this.show_tickets = null;
				}
				// console.log('showTicketSales', 'this.show_tickets ',this.show_tickets );
				// console.log('showTicketSales', 'index', index,tickets);
			},
			money(price, params) {
				return formatMoney(price, params)
			},
			first(obj) {
				if (typeof obj == 'object') {
					return Object.keys(obj)[0];
				}
				return _.first(obj);
			},
			getTicketDetailsFromFirstSale() {

			},
			log(...args) {
				console.log(...args);
			},
			lang(path, object) {
				let item = lang(path, object);

				// console.log('lang', 'item', item, path, object);
				return item;
			}
		},
		watch: {
			event_data(item) {
				// console.log('event_data', 'item', item,item.tickets.sales);
				// this.show_tickets_active = false;
			}
		},
		computed: {}
	}
</script>

<style scoped>
    .table-max-height{
        overflow-x: hidden;
        overflow-y: scroll;
        height: 250px;
    }
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/modules/EventTicketsModule.vue?31678f4e